import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { AlertTriangle, Shield, Check, Loader2, FileText } from "lucide-react";

const ReserveDealModal = ({ open, onOpenChange, onConfirm, dealAddress, loading }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]" data-testid="reserve-deal-modal">
        <DialogHeader>
          <div className="mx-auto w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mb-4">
            <Shield className="w-8 h-8 text-blue-500" />
          </div>
          <DialogTitle className="text-center text-xl font-heading">
            Reserve This Deal
          </DialogTitle>
          <DialogDescription className="text-center">
            You are about to secure this deal
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 my-4">
          <div className="bg-muted/50 rounded-lg p-4 text-center">
            <p className="font-medium text-foreground">{dealAddress}</p>
          </div>

          <div className="bg-orange-500/10 border border-orange-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
              <div className="text-sm text-orange-600 dark:text-orange-400">
                <p className="font-medium mb-2">You will be required to sign legal agreements:</p>
                <ul className="list-disc list-inside space-y-1 text-xs">
                  <li>Wholesale Agreement</li>
                  <li>Assignment Contract</li>
                  <li>Purchase Contract</li>
                  <li>Disclosures</li>
                  <li>Contingency Removal</li>
                  <li>Commission & Fee Confirmation</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <FileText className="w-5 h-5 text-blue-500 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-blue-600 dark:text-blue-400">
                Once you reserve this deal, it will be marked as "Under Contract" 
                and other investors will not be able to reserve it.
              </p>
            </div>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)} 
            className="flex-1"
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-blue-500 hover:bg-blue-600"
            data-testid="confirm-reserve-btn"
          >
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Reserving...
              </>
            ) : (
              <>
                <Check className="w-4 h-4 mr-2" />
                Continue
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ReserveDealModal;
